/**
 * 审核弹框
 */
import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import { Toast } from 'src/util/toast';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import { modalFactory } from 'src/util/vueExtend';
import DataAuditApi from './api/dataAuditApi';
import { createBEM } from 'src/util/bem';

import CommonSelect from '../../../components/SelectCustom/commonSelect';

let bem = createBEM('audit-datamodal');
export namespace AuditDataModalVOI {
    export interface PropsI {
        saveSuccess?(): void;
        cancel?(): void;
    }

    export interface FormDataI {
        data_validity: string;
        cause: any;
        remark: string;
    }
    export interface formParams {
        device_name: string;
        mn: string;
        value?: string;
        check_info: any;
        datas: any;
    }
}

@Component
class auditDataModal extends Vue.Component<AuditDataModalVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Object,
    })
    conductionParams!: AuditDataModalVOI.formParams;

    @Prop({
        type: String,
    })
    check!: string;

    @Prop({
        type: Array,
    })
    dataSource!: Array<any>;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: AuditDataModalVOI.FormDataI = {
        data_validity: '有效数据', // 数据有效性
        cause: null, // 审核原因
        remark: '', // 备注
    };
    objs: any = { name: '无', id: 0, flag: 'N', priority_level: '0' };
    // TODO 默认全选
    checkedDivisors: Array<string> = this.check == 'all' && this.conductionParams.check_info[0].components.map(i => i.component);
    checkedTimestamp: Array<string> = this.check == 'all' && this.conductionParams.check_info[0].timestamps.map(i => i.id);

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }
    async save() {
        let list: Array<{ id: string; timestamp: string; component: string; component_name: string }> = [];
        let allDataSource = [this.objs, ...this.dataSource];
        let { device_name, mn, check_info, value } = this.conductionParams;
        let { cause, data_validity, remark } = this.formData;
        if (cause == null) {
            return Toast.error('请选择审核原因');
        }
        // 获取原因标识
        let { flag, priority_level } = allDataSource.find(i => i.id == cause);
        if (this.check == 'all' && !this.checkedDivisors.length) {
            return Toast.error('请选择审核组分');
        }
        if (this.check == 'all' && !this.checkedTimestamp.length) {
            return Toast.error('请选择审核时间');
        }
        // 只有批量审核才走这里
        if (this.checkedTimestamp.length) {
            this.checkedTimestamp.forEach(item => {
                this.checkedDivisors.forEach(itemNext => {
                    list.push({
                        id: item,
                        timestamp: check_info[0].timestamps.find(i => i.id == item).timestamp,
                        component: itemNext,
                        component_name: check_info[0].components.find(i => i.component == itemNext).component_name,
                    });
                });
            });
            // 遍历datas列表
            for (let data of this.conductionParams.datas) {
              const dataId = data.id;

              // 遍历list列表，查找与当前dataId匹配的对象
              for (let i = 0; i < list.length; i++) {
                const item = list[i];
                if (item.id === dataId) {
                  const componentKey = item.component;

                  // 检查对应component的value是否为NAN
                  if (isNaN(data[componentKey].value ) || data[componentKey].value === "") {
                    // 如果value为NAN，则从list中删除该对象
                    list.splice(i, 1);
                    i--; // 调整索引以处理下一个对象
                  }
                }
              }
            }
        }
        let params = {
            device_name,
            check_info: this.check == 'one' ? check_info : list,
            mn,
            data_validity: data_validity == '有效数据',
            cause: priority_level,
            cause_id: cause,
            flag,
            remark,
            type:  this.check == 'one' ? value == ""? 1: 0 : 0,
        };
        // * API:根据站点审核数据 https://easydoc.net/s/47801620/RLpvitU3/SNS7AL3m#nav_4
        let { code } = await DataAuditApi.audit(params);
        if (code === 0) {
            this.saveSuccess();
            Toast.success('审核成功！');
            this.close();
        }
    }
    formatTime(val: any) {
        return DateTimeUtil.formateDate(val * 1000, 'HH:mm');
    }
    // * API:根据审核时间和审核因子查询审核详情
    async getChecksDetails() {
        if (this.check != 'one') return;
        let { mn, check_info } = this.conductionParams;
        let params = {
            mn,
            timestamp: check_info[0].timestamp,
            component: check_info[0].component,
        };
        let { code, data } = await DataAuditApi.getCheckDetails(params);
        if (code == 0 && data) {
            let { validity, remark, cause_id } = data;
            this.formData.data_validity = validity == 0 ? '有效数据' : '无效数据';
            this.formData.remark = remark;
            this.formData.cause = cause_id;
        }
    }
    // 监听选择数据有效性切换
    onChangeRadio() {
        let { data_validity, cause } = this.formData;
        if (data_validity == '无效数据' && cause == 0) {
            this.formData.cause = null;
        }
        else if (data_validity == '有效数据') {
            this.formData.cause = this.objs.id;
        }
    }
    mounted() {
        this.getChecksDetails();
    }
    render(h) {
        //
        let { check_info, value } = this.conductionParams;
        return (
            <Modal
                title={this.check == 'one' ? '数据审核' : '批量审核'}
                width="700"
                v-model={this.visible}
                mask-closable={false}
                on-on-cancel={this.close}
            >
                <i-form ref="formValidate" labelWidth={140} model={this.formData}>
                    <form-item labelWidth={130} label="测量时间：">
                        {this.check == 'one' ? (
                            <p>{this.formatTime(check_info[0].timestamp)}</p>
                        ) : (
                            <checkbox-group v-model={this.checkedTimestamp}>
                                {check_info[0].timestamps.map(i => {
                                    return (
                                        <checkbox size="large" label={i.id}>
                                            {this.formatTime(i.timestamp)}
                                        </checkbox>
                                    );
                                })}
                            </checkbox-group>
                        )}
                    </form-item>
                    <form-item labelWidth={130} label="测量因子：">
                        {this.check == 'one' ? (
                            <p>{check_info[0].component_name}</p>
                        ) : (
                            <checkbox-group v-model={this.checkedDivisors}>
                                {check_info[0].components.map(i => {
                                    return (
                                        <checkbox size="large" label={i.component}>
                                            {i.component_name}
                                        </checkbox>
                                    );
                                })}
                            </checkbox-group>
                        )}
                    </form-item>
                    <form-item v-if={this.check == 'one'} labelWidth={130} label="测量浓度：">
                        <p>{value ==="" ? "0.00": value}</p>
                    </form-item>
                    <form-item labelWidth={130} label="数据有效性：">
                        <radio-group v-model={this.formData.data_validity} on-change={this.onChangeRadio()}>
                            <radio size="large" label="有效数据" />
                            <radio size="large" label="无效数据" />
                        </radio-group>
                    </form-item>
                    <form-item labelWidth={130} label="原因：" style="display: block;width:50%">
                        <CommonSelect
                            dataSource={this.formData.data_validity == '有效数据' ? [this.objs] : this.dataSource}
                            v-model={this.formData.cause}
                        />
                    </form-item>
                    <form-item labelWidth={130} label="备注：" style="display: block;width:80%">
                        <i-input v-model={this.formData.remark} type="textarea" placeholder="" />
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertAuditDataModal(
    conductionParams: AuditDataModalVOI.formParams,
    check: string,
    dataSource: Array<any>,
): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<AuditDataModalVOI.PropsI>(auditDataModal)({
            conductionParams,
            check,
            dataSource,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
